import { firestore } from '@src/api/Firebase/Firebase';
import { collection } from 'firebase/firestore';

export interface DistributionCenter {
    id?: string;
    status: boolean;
    name: string;
    phone: string;
    email: string;
    managerId: string;
    address: string;
}
export const DISTRIBUTION_CENTERS_COLLECTION = 'distribution_centers';

export const distributionCentersRef = collection(firestore, DISTRIBUTION_CENTERS_COLLECTION);
